import { render, staticRenderFns } from "./subjects.vue?vue&type=template&id=c17a5898&scoped=true&"
import script from "./subjects.vue?vue&type=script&lang=js&"
export * from "./subjects.vue?vue&type=script&lang=js&"
import style0 from "./subjects.vue?vue&type=style&index=0&id=c17a5898&lang=scss&scoped=true&"
import style1 from "./subjects.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17a5898",
  null
  
)

export default component.exports